export default __webpack_public_path__ + "static/media/blank_students.83db30db.svg";